// Components
import Status, { STATUS_TYPES } from "../../../components/molecules/status";
import Button, { BUTTON_TYPES } from "../../../components/atoms/button";
import { EditOutlined, DeleteOutlined } from "../../../components/atoms/icon";

// Readers
import sportReader from "../../../readers/sport";

// Styles
import styles from "../sports.module.scss";

const createColumns = ({ onEdit, onDelete, onSort }) => {
  return [
    {
      title: "Name",
      dataIndex: 'name',
      sorter: true,
      render: (text, sportDetails) => {
        return sportReader.name(sportDetails);
      },
    },
    {
      title: "Added By",
      render: (text, sportDetails) => {
        return (
          sportReader.firstName(sportDetails) +
          " " +
          sportReader.lastName(sportDetails)
        );
      },
    },
    {
      title: "Use",
      dataIndex: 'usedCount',
      sorter: true,
      render: (text, sportDetails) => {
        const count = sportReader.used(sportDetails) || 0
        return (
          <Button
            disabled={count.length > 0 ? false : true}
            type={BUTTON_TYPES.DEFAULT}
          >
            {count.length}
          </Button >
        );
      },
    },
    {
      title: "Status",
      render: (text, sportDetails) => {
        const status = sportReader.isActive(sportDetails)
          ? STATUS_TYPES.ACTIVE
          : STATUS_TYPES.INACTIVE;
        return <Status status={status} />;
      },
    },
    {
      title: "Actions",
      render: (text, sportDetails) => {
        return (
          <>
            <Button
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(sportDetails);
              }}
              className={styles.icon}
            >
              <EditOutlined />
            </Button>
            <Button
              disabled
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(sportDetails);
              }}
              className={`${styles.icon} ${styles.iconDanger}`}
            >
              <DeleteOutlined />
            </Button>
          </>
        );
      },
    },
  ];
};

export { createColumns };
